import { render, staticRenderFns } from "./JobFittingMessage.vue?vue&type=template&id=0e2b88be&"
import script from "./JobFittingMessage.vue?vue&type=script&lang=js&"
export * from "./JobFittingMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports